<script setup>
import {computed} from "vue";
import {interpolate} from "@/utils/translate";
import QRCodeVue3 from "qrcode-vue3";

const model = defineModel({type: Boolean});
const props = defineProps({
    authenticationRequest: {
        type: Object,
    }
});
const emit = defineEmits(['close']);

const dialogTitle = computed(() => {
    return interpolate(
        pgettext('title', 'Authenticate device %(device_name)s'),
        {
            device_name: props.authenticationRequest.name,
        }
    );
});

function close() {
    emit('close');
    model.value = false;
}
</script>

<template>
    <v-dialog v-model="model" max-width="560" persistent>
        <v-card>
            <v-card-title>
                {{ dialogTitle }}
            </v-card-title>

            <v-card-text>
                <p>
                    {{ gettext('Scan the following QR code with the device you want to authenticate:') }}
                </p>

                <p class="text-center mt-4">
                    <QRCodeVue3 :value="authenticationRequest.authenticationUrl"
                                :width="300"
                                :height="300"
                                :dotsOptions="{type: 'square', color: '#000000'}"
                                :cornersSquareOptions="{type: 'square', color: '#000000'}"
                                :cornersDotOptionsHelper="{type: 'square', color: '#000000'}"/>
                </p>
                <p class="text-center mb-6">
                    <strong>{{ authenticationRequest.authenticationUrl }}</strong>
                </p>

                <p>
                    {{ gettext('Alternatively, open the authentication page on the device and enter the following code:') }}
                </p>

                <p class="text-h3 text-center my-6">
                    <code>{{ authenticationRequest.code }}</code>
                </p>
            </v-card-text>

            <v-card-actions class="bg-surface-light">
                <v-btn @click="close()">
                    {{ pgettext('action', 'Close') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
